import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "customColors",
})<{
  customColors?: StatusBadgeColors;
}>(({ customColors }) => ({
  background: customColors?.backgroundColor ?? "rgba(2, 136, 209, 0.08)",
  color: customColors?.color ?? "#42a5f5",
  fontSize: "11px",
  height: "20px",
  fontWeight: 500,
  border: customColors?.borderColor
    ? `1px solid ${customColors.borderColor}`
    : "none",
  "& .MuiChip-label": {
    padding: "1 5px",
  },
  borderRadius: "100px",
}));

const BadgeLink = styled("a")({
  color: "#1a73e8",
  fontWeight: 600,
  textDecoration: "underline",
  fontSize: "0.8rem",
});

export type StatusBadgeColors = {
  backgroundColor: string;
  color: string;
  borderColor?: string;
};

type StatusBadgeProps = {
  label: string;
  size?: "small" | "medium";
  colors?: StatusBadgeColors;
  link?: { href: string; label: string };
};

const StatusBadge = ({
  label,
  size = "small",
  colors,
  link,
}: StatusBadgeProps) => {
  const chip = <StyledChip label={label} size={size} customColors={colors} />;

  if (!link) {
    return chip;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
      {chip}
      <BadgeLink href={link.href} target="_blank" rel="noopener noreferrer">
        {link.label}
      </BadgeLink>
    </Box>
  );
};

export default StatusBadge;
